import { render, staticRenderFns } from "./SidebarBarItem.vue?vue&type=template&id=02fe3ec6&scoped=true&"
import script from "./SidebarBarItem.vue?vue&type=script&lang=js&"
export * from "./SidebarBarItem.vue?vue&type=script&lang=js&"
import style0 from "./SidebarBarItem.vue?vue&type=style&index=0&id=02fe3ec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fe3ec6",
  null
  
)

export default component.exports